import React from "react";
import { motion } from "framer-motion";
import LogoGIF from "./LogoLoader.webp";

const LogoLoader = (props) => {
  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white"
      {...props}
    >
      <div className="relative flex flex-col items-center justify-center">
        {/* Subtle background glow */}
        <div className="absolute inset-0 bg-primary/5 blur-[60px] scale-[2] rounded-full"></div>
        
        {/* Logo with pulsating animation */}
        <motion.img
          src={LogoGIF}
          alt="Loading..."
          className="relative z-10 w-56 h-auto object-contain drop-shadow-xl"
          animate={{ scale: [1, 1.05, 1], opacity: [0.85, 1, 0.85] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        />
        
        {/* Loading text container */}
        <motion.div 
          className="mt-10 flex flex-col items-center justify-center space-y-4"
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          <div className="flex items-center space-x-3 text-primary">
            {/* Elegant Spinner */}
            <svg className="w-6 h-6 animate-spin text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span className="text-xl font-semibold tracking-wide">Please wait...</span>
          </div>
          
          {/* Indeterminate Animated Progress Bar */}
          <div className="w-48 h-1.5 bg-primary/10 rounded-full overflow-hidden relative">
            <motion.div 
              className="absolute top-0 left-0 h-full bg-primary rounded-full w-1/3 shadow-[0_0_8px_rgba(30,58,138,0.6)]"
              animate={{ left: ["-40%", "100%"] }}
              transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default LogoLoader;
